import React from 'react';

import styles from './firmReferencesReorderFormStyles';

import ReorderForm from 'buyside/components/presentation/Form/ReorderForm/reorderForm';

const renderFirmReference = firmReference => (
  <div className={styles.firmReference}>
    <strong>{firmReference.name}</strong>
    <span>{firmReference.employer}</span>
  </div>
);

const FirmReferencesReorderForm = ({ modalId }) => {
  return (
    <ReorderForm
      modalId={modalId}
      attr="fundProfile.firmReferences"
      renderItem={renderFirmReference}
    />
  );
};

export default FirmReferencesReorderForm;
